<template>
    <el-collapse v-model="activeName" accordion>

      

      <div v-for="(userName, i) in data" :key="i">
        <!-- <p>{{Object.keys(userName)}}</p> -->
        <el-collapse-item  :title="userName.user" :name="i">
                  <div v-for="(document, doc) in userName.document" :key="doc">
                    <p>{{document.document_name}}
                      <span>
                        <input type="checkbox" :id="document.document_id" :value="document.is_watch" :class="document.document_id + ''+ doc "  v-if="document.is_watch == 1 " checked @click="submit(document.document_id, document.is_watch, doc)">
                        <input type="checkbox" :id="document.document_id" :value="document.is_watch" :class="document.document_id + ''+ doc "   v-else unchecked @click="submit(document.document_id, document.is_watch , doc)">
                        <label :for="document.document_id">Track Document</label>
                     </span>
                    </p>
                    <a :href="document.file.path" download>
                      <!-- <app-widget
                        v-if="
                          file.extention == 'pdf' ||
                          file.extention == 'xls' ||
                          file.extention == 'doc'
                        "
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="document.name"
                        :icon="'file-text'"
                      /> -->

                      <app-widget
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="document.file.name"
                        :icon="'image'"
                      />
                    </a>
                  </div>
                  <!-- <p>{{userName.pivot.document_id}}</p> -->
        </el-collapse-item>
      </div>
    </el-collapse>
</template>

<script>
 import {FormMixin} from '../../../../../../core/mixins/form/FormMixin';
import {GET_USER_DOCUMENT,ADD_IS_WATCH_LIST} from "../../../../../Config/ApiUrl";
import {axiosGet, axiosPost} from "../../../../../Helpers/AxiosHelper";
  export default {
    mixins: [FormMixin],
      props:{data:Object},
    data() {
      return {
        inputs:{},
        activeName: '1',
        documents:[],
      };
    },
    methods: {
      // getdocument(id) {
      //   axiosGet(GET_USER_DOCUMENT+'/'+id)
      //   .then((res) => {
      //     this.documents = res.data;
      //     // this.documentUser = res.data.attachdocumentuser;
      //     
      //   })
      //   .catch((error) => {
      //     
      //   });
      // },
      submit(id,value, index) {
        let classhas =  id + '' + index ;
        this.inputs.id = id;
        this.inputs.is_watch =  $('.'+ classhas).val();
       
        axiosPost(ADD_IS_WATCH_LIST,this.inputs)
        .then((res) => {
            $('.'+ classhas).val(res.data.is_watch);
     
        })
        .catch((error) => {
          
        });
        
      }
    },
    // mounted() {
    //   
    // }
  }
</script>